import { Injectable } from '@angular/core';
import { EventsService } from 'src/app/core/services/events.service';
import { RoutePlanerEventTracker } from 'src/app/core/events/events';
import { AppService } from '../app-service/app.service';

@Injectable({
  providedIn: 'root'
})
export class RoutePlannerEventTrackerService {
  constructor(private eventService: EventsService, private appService: AppService) {
    this.eventService.on(RoutePlanerEventTracker.TAG_VIEW, this.trackViewEventLister);
    this.eventService.on(RoutePlanerEventTracker.TAG_LINK, this.trackLinkEventLister);
  }

  private trackViewEventLister = (event) => {
    this.appService.updateTrackingAndSeo('view', {
        site_section: 'Route planner - New',
        page_url: window.location.href.replace(window.location.origin, '')
    });
  }

  private trackLinkEventLister = (event) => {
    this.appService.trackingAndSeoService.link({
        event_name: 'link copied',
        event_action: 'click',
        event_label: 'link copied - ' + window.location.href.replace(window.location.origin, '')
    });
  }
}
